// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3GjPT","alert":"SettungsInbox_alert__2D9t1"};